import request from "../request";
import sysrequest from "../sysrequest";
// 案件管理的api

const api = {
  // 案件列表查詢
  case_list(data) {
    const obj = {
      url: "/bid/demo_v1/case/list/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //建立總公司案件
  create_head_office(data) {
    const obj = {
      url: "/bid/demo_v1/case/create_head_office/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //案件詳細查詢
  case_detail(data) {
    const obj = {
      url: "/bid/demo_v1/case/detail/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //建立案件
  case_create(data) {
    const obj = {
      url: "/bid/demo_v1/case/create/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //更新案件
  case_update(data) {
    const obj = {
      url: "/bid/demo_v1/case/update/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //指派案件：
  case_assign(data) {
    const obj = {
      url: "/bid/demo_v1/case/assign/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //接受覆核
  case_approve(data) {
    const obj = {
      url: "/bid/demo_v1/case/approve/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
  //申請覆核
  case_submit(data) {
    const obj = {
      url: "/bid/demo_v1/case/submit_approval/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  case_project_options(data) {
    const obj = {
      url: "/bid/demo_v1/case_project/project_options/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 專案名稱查詢  case_project
  case_project(data) {
    const obj = {
      url: "/bid/demo_v1/case_project/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
  // case_history_list
  case_history(data) {
    const obj = {
      url: "/bid/demo_v1/case/history/list/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 申請覆核
  case_submit_approval(data) {
    const obj = {
      url: "/bid/demo_v1/case/submit_approval/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 接受覆核
  case_approve(data) {
    const obj = {
      url: "/bid/demo_v1/case/approve/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};

export default api;
